// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownIcon__root___371_G","ieMask":"DropdownIcon__ieMask___2l9LY"};